import React, { useState } from "react";
import {  FaMinus, FaPlus,  FaShieldAlt, FaHeartbeat, FaHospitalUser, FaMicroscope, FaNotesMedical, FaDna, FaLaptopMedical, FaCapsules,  FaRobot, FaClipboardList, FaFlask, FaVial, FaPrescriptionBottle, FaHandHoldingMedical, FaStethoscope, FaBolt } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/telemedicine.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Biomedical Research & Development",
        "description":
            "Advance medical science through cutting-edge biotechnology, genetic engineering, and pharmaceutical innovations. This includes developing breakthrough therapies, improving vaccine technology, and enhancing molecular diagnostics for precision medicine. Research efforts focus on gene editing, targeted drug delivery, and novel treatment modalities to combat chronic and rare diseases more effectively."
    },
    {
        "title": "Wearable Health Technology",
        "description":
            "Develop next-generation smart medical devices such as ECG monitors, continuous glucose monitors, and AI-powered fitness trackers to provide real-time health monitoring. Wearable technology facilitates early disease detection, supports chronic disease management, and enables remote patient tracking, empowering individuals to take proactive control of their health while enhancing telemedicine capabilities."
    },
    {
        "title": "AI-Powered Diagnostics",
        "description":
            "Leverage artificial intelligence and machine learning to analyze medical imaging, pathology slides, and genomic data for early disease detection and precision diagnostics. AI-driven tools improve diagnostic accuracy, reduce human error, accelerate decision-making, and provide predictive insights for conditions such as cancer, cardiovascular diseases, and neurodegenerative disorders."
    },
    {
        "title": "Point-of-Care Testing (POCT)",
        "description":
            "Enhance rapid diagnostics with portable, AI-integrated testing devices that deliver immediate results for infectious diseases, diabetes, cardiac markers, and other critical conditions. POCT solutions reduce diagnostic turnaround times, increase accessibility to healthcare in remote areas, and support faster clinical decision-making in emergency and primary care settings."
    },
    {
        "title": "Regenerative Medicine & Bioprinting",
        "description":
            "Revolutionize treatment approaches with tissue engineering, stem cell therapy, and 3D bioprinting of organs and tissues. These innovations aim to repair or replace damaged tissues, accelerate wound healing, and provide patient-specific implants. Regenerative medicine offers promising solutions for conditions such as organ failure, spinal cord injuries, and degenerative diseases."
    },
    {
        "title": "Medical Robotics & Automation",
        "description":
            "Integrate robotics into surgery, rehabilitation, and patient care to enhance precision, efficiency, and clinical outcomes. Innovations include robotic-assisted surgeries for minimally invasive procedures, AI-driven rehabilitation exoskeletons for mobility improvement, and automated medication dispensers for better patient adherence and safety. Robotics and automation reduce human error, optimize healthcare workflows, and improve patient recovery rates."
    }
]

const features = [
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Development of cutting-edge devices that improve diagnosis, treatment, and monitoring, from diagnostic tools to therapeutic implants." },
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Smart devices such as wearables, biosensors, and fitness trackers that monitor real-time health metrics and improve chronic disease management." },
    // { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Pharmaceutical research and drug discovery processes." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Integrating data from biotech products and medical devices with health IT systems, providing real-time data access for clinical decision-making." },
    { icon: <FaVial className="text-[#2a627a] text-lg" />, text: "Research in the biotech field, including drug discovery, gene therapy, and regenerative medicine, to advance healthcare treatments." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Ensuring that all products meet global medical regulations such as FDA, CE marking, and ISO standards, and streamlining reporting for compliance." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "By leveraging innovative technologies and agile development processes, we speed up the creation and delivery of new biotech and medical devices." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Our solutions help biotech companies and medical device manufacturers create products that directly improve patient care, treatment efficacy, and quality of life." },
    { icon: <FaPrescriptionBottle className="text-[#2a627a] text-lg" />, text: "Wearable and remote monitoring devices enable continuous tracking of health metrics, empowering patients and providers with better information for proactive care." },
    { icon: <FaHandHoldingMedical className="text-[#2a627a] text-lg" />, text: "We ensure that all medical devices and biotech products comply with international regulations and standards, reducing the risk of costly non-compliance issues." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Through streamlined processes and data-driven insights, we help reduce development costs, improve operational efficiency, and bring products to market faster." },
    // { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Ensures compliance with medical device safety regulations." }
];
const cmsFeatures = [
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Biomedical Engineer – Designs and tests innovative medical devices." },
    { icon: <FaRobot className="text-[#2a627a] text-lg" />, text: "Medical Robotics Specialist – Develops AI-driven robotic healthcare solutions." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Clinical Research Scientist – Conducts biotech trials and studies." },
    { icon: <FaBolt className="text-[#2a627a] text-lg" />, text: "Bioinformatics Specialist – Analyzes genetic and biological data for drug development." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Product Development Manager –Oversees the development of new biotech and medical device products, ensuring compliance with medical standards and optimizing device functionality." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Clinical Research Scientist – Develops clinical trials and research methods to assess the efficacy of new biotech treatments and medical devices." }
];
const Biotech = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  flex justify-center items-center">Biotech & Medical Devices - <span className="text-gray-800"> HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Revolutionizing healthcare through innovative biotechnology and advanced medical devices to enhance diagnostics, treatment, and patient well-being."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Biotech & Medical Devices? </h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Biotech and medical devices refer to the technologies and innovations used to improve patient care and treatment outcomes. Biotech involves the development of biologics and pharmaceuticals, while medical devices include equipment used for diagnosis, treatment, or prevention of diseases. These industries are focused on transforming healthcare through cutting-edge innovations, from gene therapy and diagnostics to wearable health devices and implantable medical devices.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Biotech & Medical Devices
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                 <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

<span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Biotech;
